import React from 'react';
import { PropTypes } from 'prop-types';
import { Link, withRouter } from 'react-router-dom';

const Navigator = ({ match: { params, url } }) => {
  const links = url.split('/');
  const hasLayout = params && params.layout;
  const hasPostCategory = params && params.postCategory;
  const hasTab = params && params.tab;
  return (
    <div className="border-b border-black my-4 pb-4 font-americaMonoRegular text-xs uppercase text-black w-full">
      <Link to="/cms"><span className="text-black">Cms</span></Link>
      {hasTab
        && (
        <>
          {' > '}
          <Link to={`/cms/${params.tab}`}>
            <span className="text-black">{params.tab}</span>
          </Link>
        </>
        )}
      {hasPostCategory
        && (
        <>
          {' > '}
          <Link to={`/cms/structure/${params.postCategory}`}>
            <span className="text-black">{params.postCategory}</span>
          </Link>
        </>
        )}
      {links.includes('choose-layout')
        && (
        <>
          {' > '}
          <Link to={`/cms/structure/${params.postCategory}/choose-layout`}>
            <span className="text-black">Choose layout</span>
          </Link>
        </>
        ) }
      { hasTab && hasPostCategory && hasLayout
      && (
      <>
        {' > '}
        <span className="text-black">{links[links.length - 1]}</span>
      </>
      ) }
    </div>
  );
};

Navigator.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default withRouter(Navigator);
